import { render, staticRenderFns } from "./image-uploader-dropzone.vue?vue&type=template&id=0c843766&scoped=true"
import script from "./image-uploader-dropzone.vue?vue&type=script&lang=js"
export * from "./image-uploader-dropzone.vue?vue&type=script&lang=js"
import style0 from "./image-uploader-dropzone.vue?vue&type=style&index=0&id=0c843766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c843766",
  null
  
)

export default component.exports